import React from 'react';
import Loadable from '@/common/lazy/Loadable';
import imports from '@/routing/imports';
import OnbLoader from '@/ui/OnbLoader';
import './ForcePasswordForm.less';
import { fireGAEvent } from '@/analytics';
import PopupNg from '@/ui/PopupNg';
import i18n from '@i18n';

const ForcePasswordLoadable = Loadable({
    loader: imports.profile,
    loading: OnbLoader,
    exp: Exp => Exp.ForcePasswordLoadable
});

function logout(e) {
    e.preventDefault();
    fireGAEvent('Vynutena zmena hesla', 'Odhlasenie');
    PopupNg.dispatcher.open('account/logout');
}

export default function ForcePasswordForm() {
    return (
        <main id="page" role="main">
            <div className="transparent-header-logout">
                <a onClick={logout}>{i18n('menu.odhlasenie')}</a>
            </div>
            <ForcePasswordLoadable />
        </main>
    );
}
